import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function Kontak() {
    const navigate = useNavigate();
    const [kontak, setKontak] = useState([]);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/kontak/readKontak`);
            const data = await response.data;

            setKontak(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/kontak/deleteKontak/${id}`
                    );
                    fetchData();
                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
            width: "300px",
        },
        {
            name: "Alamat",
            selector: (row) => row.alamat,
            sortable: true,
            width: "400px",
        },
        {
            name: "Jam Kerja",
            selector: (row) => row.jamkerja,
            sortable: true,
            width: "200px",
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/kontakEdit/${row.id}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button onClick={() => handleDelete(row.id)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
            width: "150px",
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Kontak</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Kontak</h3>
                                    </div>
                                    <div className="card-body">
                                        {kontak === 0 && (
                                            <Link to="/kontakAdd" className="btn btn-primary">
                                                <i className="nav-icon fas fa-plus mr-2" />
                                                Add Data
                                            </Link>
                                        )}
                                        <DataTable columns={columns} data={kontak} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Kontak;
